import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import jaLocale from "i18n-iso-countries/langs/ja.json";

// Register locales
countries.registerLocale(enLocale);
countries.registerLocale(jaLocale);

/**
 * Generates the country list in the format expected by the form.
 * You can change "en" to "ja" here to change the global output.
 */
const getCountryList = (lang = "en") => {
  const countryObj = countries.getNames(lang, { select: "official" });
  return Object.entries(countryObj).map(([code, name]) => ({
    name: name,
    code: code,
  }));
};

// Export as the same name used in RegisterForm.tsx
export const allCountries = getCountryList("en");

const allJpVisaTypes = [
  { name: "Work Visa", code: "WORK" },
  { name: "Student Visa", code: "STUDENT" },
  { name: "Tourist Visa", code: "TOURIST" },
  { name: "Spouse Visa", code: "SPOUSE" },
  { name: "Business Visa", code: "BUSINESS" },
];

const allJpLevels = [
  { name: "N1", code: "N1" },
  { name: "N2", code: "N2" },
  { name: "N3", code: "N3" },
  { name: "N4", code: "N4" },
  { name: "N5", code: "N5" },
];
export { allJpVisaTypes, allJpLevels };
